import Image from 'next/image'
import Cookies from 'universal-cookie'
import dynamic from 'next/dynamic'
import ImageWithBasePath from '../../components/ImageWithBasePath'
import {
  LAT_LONG_LOCATION_SEARCH,
  MICRO_LOCATION_SEARCH,
  POPULAR_CITIES,
  GET_lOCATION_LIST
} from '../../constants/all'
import { getAsPath, getAsPathLocationSelectionPage, getMethod, multipleGetCalls } from '../../utils/functions'
import { useContext, useEffect, useRef, useState } from 'react'
import { seekersAnalayticOptions } from '../../utils/functions'
const VerticalRadioGroup = dynamic(() => import('../../commonComponents/VerticalRadioGroup'), {
  loading: () => <p>Loading...</p>,
  error: () => <p>Error!</p>
})
import { CircularSpinner } from '../../components/CircularSpinner'
import { useRouterHook } from '../../hooks/useRouterHook'
import { Media } from '../../commonComponents/Media'
import { NextLink } from '../../commonComponents/NextLink'
import { Pagination } from '../../components/Pagination'
import { seekersPageScripts } from '../_app'
import { useRouter } from 'next/router'
import { pageview, trackEvent } from '../../analytics'
import { SharedContext } from '../../context/SharedContext'
import { SeekerContext } from '../../context/SeekerContext'

const LocationSelectionPage = ({ cities }) => {
  const [cityList, setCityList] = useState([])
  const [allCityList, setAllCityList] = useState([])
  const {
    location,
    setLocation,
    loginDetails,
    utmParams
  } = useContext(SharedContext);
  
  const {
    setCurrentPage,
    filterTitleIds,
    body
  } = useContext(SeekerContext);
  const [latLong, setLatLong] = useState({})
  const [isGeoLocationLoading, setIsGeoLocationLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { navigateToPagesInSeeker } = useRouterHook()
  const [errorId, setErrorId] = useState([])
  const [isFocused, setIsFocused] = useState(false)
  const inputRef = useRef()
  const [pagination, setPagination] = useState({ pageNumber: 1, hasMore: true })
  const route = useRouter()
  const [hydrated, setHydrated] = useState(false)
  const {clicked} = route.query

  async function getCityList(value) {
    let params
    let list = []
    params = { q: value }
    let headers = { 'App-Type': 'web' }
    const response = await getMethod({
      url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${MICRO_LOCATION_SEARCH}`,
      params,
      headers
    })
    if (response && response?.['results']) {
      response?.['results'].forEach((element) => {
        list.push(element)
      })
      setCityList(list)
    }
  }

  async function getAllCitiesList(firstCall = false) {
    const params = {
      page: firstCall ? pagination.pageNumber : pagination.pageNumber + 1,
      type: 'all'
    }
    const headers = { 'App-Type': 'web' }
    const response = await getMethod({
      url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${GET_lOCATION_LIST}`,
      params,
      headers
    })
    if (response?.results?.length > 0)
      setAllCityList((prv) => {
        let results
        if (prv?.length) results = [...prv, ...response?.results]
        else results = response?.results
        return results
      })
    else setPagination((prv) => ({ ...prv, hasMore: false }))
    setPagination((prv) => ({ ...prv, pageNumber: prv.pageNumber + 1 }))
  }

  useEffect(() => {
    setHydrated(true)
    trackEvent({
      name: 'viewed_location_screen',
      searchParams: {
        ...utmParams
      },
      options: {
        ...seekersAnalayticOptions(window, loginDetails, location, 'impression', 'jobs'),
        source: 'website',
        category_name_eng: 'jobs'
      },
      isSeeker: true
    })
    getAllCitiesList(true)
  }, [])

  const fetchNextJobDetails = async () => {
    const data = await APIGet(
      PROMOTED_JOBS_END_URL,
      { 'Accept-Language': language, source: 'jobs_web', 'App-Type': 'web' },
      {
        page: pagination.pageNumber + 1,
        location_id: location?.id || 9,
        category_id: 2
      }
    )
    if (data?.results?.length > 0)
      setSponsoredJobsObject((prv) => {
        let results
        if (prv?.results) results = [...prv?.results, ...data?.results]
        else results = data?.results
        prv.results = results
        return { ...prv }
      })
    else setPagination((prv) => ({ ...prv, hasMore: false }))
    setPagination((prv) => ({ ...prv, pageNumber: prv.pageNumber + 1 }))
  }

  const handleClearInput = () => {
    setIsFocused(false)
    setLocation(null)
    getCityList()
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  useEffect(() => {
    if (cityList?.length == 0) {
      getCityList()
    }
    setIsGeoLocationLoading(false)
  }, [])

  async function getCurrentLocation() {
    setIsGeoLocationLoading(true)
    const timeoutId = setTimeout(() => {
      setIsGeoLocationLoading(false)
      setIsError(true)
    }, 5000)

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((el) => {
        clearTimeout(timeoutId)
        setLocationAndConstituency(el),
          (error) => {
            setIsGeoLocationLoading(false)
            setIsError(true)
            console.error('Geolocation error:', error)
          }
      })
    }
  }

  async function setLocationAndConstituency(el) {
    setLatLong({ latitude: el.coords.latitude, longitude: el.coords.longitude })
    let params
    let headers
    params = { lat: el.coords.latitude, long: el.coords.longitude }
    headers = { 'App-Type': 'web' }
    const response = await getMethod({
      url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${LAT_LONG_LOCATION_SEARCH}`,
      params,
      headers
    })
    if (Object.keys(response).length === 0) {
      setIsError(true)
      setIsGeoLocationLoading(false)
      setCurrentPage(0)
      navigateToPagesInSeeker({ pathName: 'jobsFiltering', as: 'jobs-near-me' })
    } else {
      setIsError(false)
      setIsGeoLocationLoading(false)
      setLocation(response?.city)
      setCurrentPage(0)
      navigateToPagesInSeeker({
        pathName: 'jobsFiltering',
        as: `jobs/jobs-in-${response?.city?.title}`
      })
    }
  }

  if (!hydrated) {
    return seekersPageScripts()
  }

  return (
    <>
      {seekersPageScripts()}

      <div>
        <div className="from-[rgba(231, 243, 254, 0.40)] via-transparent to-transparent flex justify-between bg-gradient-to-t py-[16px] px-[12px]">
          <h2 className="mb-[0px] font-noto-sans text-[18px] font-bold leading-[27px] text-[#323232]">
            Provide your location & find jobs near you
          </h2>
          <div>
            <ImageWithBasePath src="maps" width={60} height={41.63} alt="maps" />
          </div>
        </div>
        <div className="relative px-[12px]">
          <div className="flex overflow-hidden rounded-sm border-[1px] border-solid border-[#666666] py-[8px] pl-[8px] pr-[16px]">
            <div>
              <ImageWithBasePath src="search" width={24} height={24} alt="search" />
            </div>
            <div className="relative">
              <input
                ref={inputRef}
                className="w-[85vw] border-none bg-transparent font-noto-sans text-[14px] font-normal leading-[21px] text-[#191919] placeholder-[#989898] outline-none"
                placeholder="Search"
                onChange={(e) => {
                  getCityList(e.target.value)
                  setIsFocused(true)
                  setLocation(null)
                }}
                value={location?.name || location?.title}
              ></input>
              <Media at="sm">
                <button
                  className="absolute right-1 top-1/2 -translate-y-1/2 transform border-none bg-transparent"
                  onClick={handleClearInput}
                >
                  <ImageWithBasePath src="cancel_image" width={20} height={20} alt={'cancle'} />
                </button>
              </Media>
            </div>
          </div>
        </div>
        <Media at="sm">
          {isFocused && (
            <div className="px-[12px]">
              <div className="absolute z-30  mt-[2px] w-[93.2vw] rounded-[6px] border-[1px] border-solid border-[#989898] bg-[#FFF] px-[12px]">
                {cityList.map((city, index) => {
                  return (
                    <div key={index} className="pt-[12px] text-[#323232]">
                      <NextLink
                        id={`locationSelectionSM ${city?.title || city?.name}`}
                        href={clicked === 'create_profile' ? 'create_profile' : 'jobsFiltering'}
                        as={
                          clicked === 'create_profile'
                            ? 'jobs/create_profile'
                            : `jobs/${getAsPath({ selectedOptions: body?.selectedOptions, filterTitleIds })}`
                        }
                        isLoader={false}
                        onClick={async () => {
                          await setLocation(city)
                          setCurrentPage(0)
                        }}
                      >
                        <div
                          className="text-[#323232]"
                          // onClick={() => {
                          //   setLocation(city)
                          //   setCurrentPage(0)
                          // }}
                        >
                          {city.title}
                        </div>
                      </NextLink>
                      <div className="border-[1px] border-r-none  border-t-none border-l-none border-solid border-[#E5E5E5] pt-[12px]"></div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </Media>

        <div
          className="flex cursor-pointer bg-[#F9F9F9] p-[12px]"
          onClick={() => {
            getCurrentLocation()
          }}
        >
          <div className="mr-[4px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clipPath="url(#clip0_1795_4591)">
                <path
                  d="M8.00065 5.33317C9.47398 5.33317 10.6673 6.5265 10.6673 7.99984C10.6673 9.47317 9.47398 10.6665 8.00065 10.6665C6.52732 10.6665 5.33399 9.47317 5.33399 7.99984C5.33399 6.5265 6.52732 5.33317 8.00065 5.33317ZM2.04065 7.33317C2.34732 4.55317 4.55398 2.3465 7.33398 2.03984V1.33317C7.33398 0.966504 7.63399 0.666504 8.00065 0.666504C8.36732 0.666504 8.66732 0.966504 8.66732 1.33317V2.03984C11.4473 2.3465 13.654 4.55317 13.9607 7.33317H14.6673C15.034 7.33317 15.334 7.63317 15.334 7.99984C15.334 8.3665 15.034 8.6665 14.6673 8.6665H13.9607C13.654 11.4465 11.4473 13.6532 8.66732 13.9598V14.6665C8.66732 15.0332 8.36732 15.3332 8.00065 15.3332C7.63399 15.3332 7.33398 15.0332 7.33398 14.6665V13.9598C4.55398 13.6532 2.34732 11.4465 2.04065 8.6665H1.33399C0.967319 8.6665 0.667318 8.3665 0.667318 7.99984C0.667318 7.63317 0.967319 7.33317 1.33399 7.33317H2.04065ZM8.00065 12.6665C10.5807 12.6665 12.6673 10.5798 12.6673 7.99984C12.6673 5.41984 10.5807 3.33317 8.00065 3.33317C5.42065 3.33317 3.33399 5.41984 3.33399 7.99984C3.33399 10.5798 5.42065 12.6665 8.00065 12.6665Z"
                  fill="#0174D3"
                />
              </g>
              <defs>
                <clipPath id="clip0_1795_4591">
                  <rect width={16} height={16} fill="white" transform="matrix(-1 0 0 1 16 0)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="font-noto-sans text-[12px] font-normal leading-[16px] text-[#0174D3]">
            Detect my current location
          </div>
          {isGeoLocationLoading ? (
            <>
              <div className="ml-[8px]">
                <CircularSpinner width="16" height="16"></CircularSpinner>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="p-[10px]">
          <div className="mt-[12px] mb-[24px] font-noto-sans text-[16px] font-normal leading-[24px] text-[#4B4B4B]">
            Popular Cities
          </div>
          <div className="flex flex-wrap gap-x-[24px] gap-y-[10px] md:justify-between">
            {Array.isArray(cities) ? (
              cities?.map((city, index) => {
                return (
                  <NextLink
                    id={`location_Selection ${city?.title || city?.name}`}
                    key={index}
                    href={clicked === 'create_profile' ? 'create_profile' : 'jobsFiltering'}
                    as={
                      clicked === 'create_profile'
                        ? 'jobs/create_profile'
                        : `jobs/${getAsPath({ selectedOptions: body?.selectedOptions, filterTitleIds })}`
                    }
                    isLoader={false}
                    onClick={async () => {
                      await setLocation(city)
                      setCurrentPage(0)
                    }}
                  >
                    <div
                      // onClick={() => {
                      //   setLocation(city)
                      //   setCurrentPage(0)
                      // }}
                    >
                      <div className=" overflow-hidden rounded-full">
                        <Image src={city?.image} width={64} height={64} alt={city?.name} />
                      </div>
                      <div className="mt-[10px] flex justify-center font-noto-sans text-[12px] font-normal leading-[16px] text-[#666]">
                        {city?.name}
                      </div>
                    </div>
                  </NextLink>
                )
              })
            ) : (
              <></>
            )}
          </div>
          <div className="mt-[14px] h-[1px] w-[100%] bg-[#E5E5E5]"></div>
          <div className="mt-[12px] mb-[17px] font-noto-sans text-[16px] font-normal leading-[24px] text-[#4B4B4B]">
            Other Cities
          </div>
          <Pagination
            listLength={allCityList?.length}
            next={getAllCitiesList}
            hasMore={pagination.hasMore}
            loader={<CircularSpinner />}
            className="overflow-hidden"
          >
            <div className="ml-[4px]">
              <VerticalRadioGroup
                {...{
                  id: 'cities',
                  value: location?.id,
                  listOfTags: allCityList,
                  onClick: async (city) => {
                    await setLocation(city)
                    setCurrentPage(0)
                    navigateToPagesInSeeker({
                      pathName: clicked === 'create_profile' ? 'create_profile' : 'jobsFiltering',
                      as:
                        clicked === 'create_profile'
                          ? 'jobs/create_profile'
                          : `${getAsPathLocationSelectionPage({ selectedOptions: body?.selectedOptions, filterTitleIds })}`
                    })
                  },
                  isOptional: false,
                  isError: false,
                  needItem: true,
                  contextItem: false
                }}
              />
            </div>
          </Pagination>
        </div>
      </div>
    </>
  )
}

export default LocationSelectionPage

export const getServerSideProps = async (context) => {
  const { req } = context
  const cookies = new Cookies()
  const language = cookies.get('language')
  const apiDetails = [
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + POPULAR_CITIES,
      header: { 'Accept-Language': language, 'App-Type': 'web' },
      isTokenPresent: false
    }
  ]
  const res = await multipleGetCalls(apiDetails)

  return {
    props: {
      cities: res?.[0] || []
    }
  }
}
